import React from 'react';

import { Box, Flex } from '@rover/kibble/core';
import Markdown from '@rover/kibble/patterns/Markdown';
import { BhCtaButton } from '@rover/pages/src/bright-horizons/HubPage/common/BhCtaButton';
import Alert, { AlertSeverity } from '@rover/react-lib/src/components/notifications/Alert/Alert';
import type { BrightHorizonsSitterProfileBanner } from '@rover/rsdk/src/apiClient/latest/model/brightHorizonsSitterProfileBanner';
import { isReactNative } from '@rover/rsdk/src/modules/Network/userAgent';

type Props = {
  brightHorizonsBanner?: BrightHorizonsSitterProfileBanner;
};

export const BHSitterProfileBanner: React.FC<Props> = ({ brightHorizonsBanner }) => {
  if (!brightHorizonsBanner?.bannerMessage) return null;
  const isMobileApp = isReactNative();

  // Use less bottom padding on mobile when button is absent (PT full condensed)
  const hasButton = !!brightHorizonsBanner.button;
  const shouldReducePadding = !hasButton && isMobileApp;
  const bottomPadding = shouldReducePadding ? '1x' : '3x';

  const singleLineBreaks = brightHorizonsBanner.bannerMessage.split('\\sn');
  return (
    <Alert
      severity={brightHorizonsBanner.severity as AlertSeverity}
      borderWidth="0px"
      borderRadius="secondary"
      paddingTop="3x"
      paddingBottom={bottomPadding}
      paddingX="4x"
    >
      <Flex flexDirection="row" flexWrap="wrap" alignItems="start" mt={isMobileApp ? '-2x' : '0x'}>
        <Box>
          {singleLineBreaks
            ? singleLineBreaks.map((line, index) => <Markdown key={index}>{line}</Markdown>)
            : null}
        </Box>
        <BhCtaButton
          cta={brightHorizonsBanner.button}
          asLink
          fontWeight="semibold"
          padding="0x"
          mt={isMobileApp ? '-4x' : '0x'}
        />
      </Flex>
    </Alert>
  );
};
